<template>
  <div>
    <div class="hidden xl:block fixed left-menu rounded-lg bg-gray-200 left-0 shadow-xl border-gray-300 border">
      <div class="">

        <div class="pl-4 pt-4">
          Logged in as:
        </div>
        <div class="p-3 mt-0 flex flex-row items-center justify-center flex-row">
          <div>
            <img class="w-12" src="../ics/avatar.svg" alt="avatar">
          </div>
          <div class="ml-3" v-if="me">
            <div class=" p-2 font-bold hello-tada" :key="me.user.username">
              @{{ me.user.username }}
            </div>

            <div @click="logoutMe()" class="btn btn-outline-gray">
              Logout
            </div>
          </div>
        </div>
        <div class="pl-4 pt-4">
          Swtich Accounts
        </div>
        <div class="pl-4 pt-4">
          <li :key="profile.user._id" v-for="profile in accounts" class=" cursor-pointer" :class="{ 'text-blue-600': profile.jwt === (me && me.jwt) }" @click="changeProfile({ profile })">
            {{ profile.user.username }}
          </li>
          <div>
            <div @click="$router.push('/login')">
              + Accounts
            </div>
          </div>
        </div>
        <!-- <div class="flex justify-around px-3 pt-4">

          <img class="cursor-pointer w-10" src="../ics/rabbit.svg" alt="avatar">
          <img class="cursor-pointer w-10" src="../ics/avatar.svg" alt="avatar">
          <img class="cursor-pointer w-10" src="../ics/rabbit.svg" alt="avatar">
          <img class="cursor-pointer w-10" src="../ics/avatar.svg" alt="avatar">
        </div> -->
      </div>

      <div class="h-4"></div>
      <hr>
      <div class="px-5 text-teal-600 cursor-pointer py-5 outline" @click="$router.push('/app/composer')">
        * Create a Post *
      </div>
    </div>
  </div>
</template>

<script>
import * as API from '../../api/api.js'
export default {
  data () {
    return {
      state: API.state
    }
  },
  computed: {
    me () {
      return this.state.me
    },
    accounts () {
      return this.state.users
    }
  },
  methods: {
    changeProfile ({ profile }) {
      API.changeProfile({ profile })
    },
    logoutMe () {
      let user = this.me.user.username
      if (window.confirm(`Do you want to logout this account?\n${user}`)) {
        API.forgetMe({ profile: this.me })
        if (this.accounts.length === 0) {
          this.$router.push('/')
        }
        window.alert('Successfully Logged Out\n' + user)
      }
    }
  }
}
</script>

<style scoped lang="postcss">
.left-menu{
  top: calc(4rem + 2rem);
  padding-bottom: 2rem;
  width: 14rem;
  /* 36rem = main content */
  left: calc(50% - (2rem + 14rem) / 2 - 36rem / 2 - 14rem / 2);
  /* height: calc; */

}

</style>
